import { Link } from "react-router-dom";
import { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "../assets/css/main.css";
import { useAuth } from "../hooks/useAuth";

const Sidebar = () => {
  const [showAdminSubmenu, setShowAdminSubmenu] = useState(false);
  const { hasPermission } = useAuth();
  return (
    <div
      className="left side-menu bg-green-500"
      style={{
        background: "#a3ddbf",
        position: "fixed",
        height: "100vh",
        overflowY: "auto",
      }}
    >
      <div className="sidebar-inner">
        <div id="sidebar-menu" style={{ height: "100%" }}>
          <ul>
            {hasPermission("view-dashboard") && (
              <li className="has_sub">
                <Link to="/dashboard" className="waves-effect">
                  <i className="fa fa-home"></i>
                  <span style={{ marginLeft: "10px" }}> Dashboard </span>
                </Link>
              </li>
            )}
            {hasPermission("view-users") && (
              <li className="has_sub">
                <Link to="/user" className="waves-effect">
                  <i className="fa fa-users"></i>
                  <span style={{ marginLeft: "10px" }}> User </span>
                </Link>
              </li>
            )}
          </ul>
          <div className="clearfix"></div>
        </div>
        <div className="clearfix"></div>
      </div>
    </div>
  );
};

export default Sidebar;
